export default __webpack_public_path__ + "static/media/MEIN_PROSPEKT_MANUAL.df74ce2d.png";